var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid", attrs: { id: "scorecardContainer" } },
    [
      _c("loading", {
        attrs: { active: _vm.loading, "can-cancel": false },
        on: {
          "update:active": function ($event) {
            _vm.loading = $event
          },
        },
      }),
      !_vm.data.selected.unit
        ? _c(
            "div",
            {
              staticClass: "alert alert-danger text-center",
              attrs: { role: "alert" },
            },
            [
              _c("h2", { staticClass: "text-danger" }, [
                _vm._v(" " + _vm._s(_vm.$t("pleaseSelectUnit")) + " "),
              ]),
            ]
          )
        : _vm._e(),
      !_vm.data.navBarRefresh && _vm.data.selected.unit
        ? _c("div", { staticClass: "pt-4" }, [
            _c("h2", { staticClass: "text-center mb-4 title" }, [
              _vm._v(" " + _vm._s(_vm.$t("outageScorecardOverview")) + " "),
            ]),
            _c("div", { staticClass: "col-12 scorecard-header-container" }, [
              _c("div", { staticClass: "row pb-2 pt-2 scorecard-header" }, [
                _c(
                  "div",
                  { staticClass: "col-2" },
                  [
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.$t("plant")) + " / " + _vm._s(_vm.$t("unit"))
                      ),
                    ]),
                    _c("column-sorting", {
                      attrs: {
                        fields: ["plantName", "unitName"],
                        "active-sort": _vm.activeSort,
                      },
                      on: { sort: _vm.sort },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-2" },
                  [
                    _c("strong", [_vm._v(_vm._s(_vm.$t("outageManager")))]),
                    _c("column-sorting", {
                      attrs: {
                        fields: ["outageManager"],
                        "active-sort": _vm.activeSort,
                      },
                      on: { sort: _vm.sort },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-2" },
                  [
                    _c("strong", [_vm._v(_vm._s(_vm.$t("outageId")))]),
                    _c("column-sorting", {
                      attrs: {
                        fields: ["outageId"],
                        "active-sort": _vm.activeSort,
                      },
                      on: { sort: _vm.sort },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-1" },
                  [
                    _c("strong", [_vm._v(_vm._s(_vm.$t("phase")))]),
                    _c("column-sorting", {
                      attrs: {
                        fields: ["currentPhase"],
                        "active-sort": _vm.activeSort,
                      },
                      on: { sort: _vm.sort },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-2" },
                  [
                    _c("strong", [_vm._v(_vm._s(_vm.$t("startDate")))]),
                    _c("column-sorting", {
                      attrs: {
                        fields: ["startDate"],
                        "active-sort": _vm.activeSort,
                      },
                      on: { sort: _vm.sort },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-1" },
                  [
                    _c("strong", [_vm._v(_vm._s(_vm.$t("duration")))]),
                    _c("column-sorting", {
                      attrs: {
                        fields: ["duration"],
                        "active-sort": _vm.activeSort,
                      },
                      on: { sort: _vm.sort },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-1" },
                  [
                    _c("strong", [_vm._v(_vm._s(_vm.$t("daysToGo")))]),
                    _c("column-sorting", {
                      attrs: {
                        fields: ["daysToGo"],
                        "active-sort": _vm.activeSort,
                      },
                      on: { sort: _vm.sort },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-1" },
                  [
                    _c("strong", [_vm._v(_vm._s(_vm.$t("score")))]),
                    _c("column-sorting", {
                      attrs: {
                        fields: ["totalScore"],
                        "active-sort": _vm.activeSort,
                      },
                      on: { sort: _vm.sort },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "scorecard-list-container col-12 pt-2" },
              _vm._l(_vm.scorecards, function (scorecard, index) {
                return _c("scorecard-list-item", {
                  key: index,
                  attrs: { scorecard: scorecard, index: index },
                  on: { "details-clicked": _vm.showScorecardDetails },
                })
              }),
              1
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "scorecardModal",
            "data-toggle": "modal",
            tabindex: "-1",
            role: "dialog",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-lg modal-dialog-centered",
              staticStyle: { width: "1200px" },
              attrs: { role: "document" },
            },
            [
              _vm.selectedScorecard !== null
                ? _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "modal-header" }, [
                      _c("h5", { staticClass: "modal-title" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("outageScorecard")) +
                            " - " +
                            _vm._s(_vm.selectedScorecard.outageId) +
                            " "
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "modal-body" }, [
                      _c(
                        "div",
                        {
                          staticClass: "col-12 scorecard-details-general mb-2",
                        },
                        [
                          _c("div", { staticClass: "row mb-2 mt-2" }, [
                            _c("div", { staticClass: "col-2" }, [
                              _c("strong", [_vm._v(_vm._s(_vm.$t("unit")))]),
                            ]),
                            _c("div", { staticClass: "col-6 text-left" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.selectedScorecard.unitName) +
                                  " "
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "row mb-2" }, [
                            _c("div", { staticClass: "col-2" }, [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.$t("outageManager"))),
                              ]),
                            ]),
                            _c("div", { staticClass: "col-6 text-left" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedScorecard.outageManager,
                                    expression:
                                      "\n                                        selectedScorecard.outageManager\n                                    ",
                                  },
                                ],
                                staticClass:
                                  "\n                                        form-control form-control-sm\n                                        outage-manager-input\n                                    ",
                                attrs: {
                                  type: "text",
                                  placeholder: _vm.$t("outageManager"),
                                },
                                domProps: {
                                  value: _vm.selectedScorecard.outageManager,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.selectedScorecard,
                                      "outageManager",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                          _c("div", { staticClass: "row mb-2" }, [
                            _c("div", { staticClass: "col-2" }, [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.$t("outageId"))),
                              ]),
                            ]),
                            _c("div", { staticClass: "col-6 text-left" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.selectedScorecard.outageId) +
                                  " "
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "row mb-2" }, [
                            _c("div", { staticClass: "col-2" }, [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.$t("startDate"))),
                              ]),
                            ]),
                            _c(
                              "div",
                              { staticClass: "col-6 text-left" },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "calendar-alt" },
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("dateFormat")(
                                        new Date(
                                          _vm.selectedScorecard.startDate
                                        ),
                                        "YYYY-MM-DD HH:mm"
                                      )
                                    ) +
                                    " "
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "row mb-2" }, [
                            _c("div", { staticClass: "col-2" }, [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.$t("duration"))),
                              ]),
                            ]),
                            _c(
                              "div",
                              { staticClass: "col-6 text-left" },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "clock" },
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.selectedScorecard.duration) +
                                    " "
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "row mb-2" }, [
                            _c("div", { staticClass: "col-2" }, [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.$t("daysToGo"))),
                              ]),
                            ]),
                            _c(
                              "div",
                              { staticClass: "col-6 text-left" },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "stopwatch" },
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.selectedScorecard.daysToGo) +
                                    " "
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-2" }, [
                              _c("strong", [_vm._v(_vm._s(_vm.$t("score")))]),
                            ]),
                            _c("div", { staticClass: "col-6 text-left" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.selectedScorecard.totalScore.toFixed(0)
                                  ) +
                                  " % "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _c("div", { staticClass: "col-12 values-list" }, [
                        _c(
                          "div",
                          { attrs: { id: "phaseAccordion" } },
                          [
                            _c("milestone-accordion", {
                              attrs: {
                                list: _vm.kpisGroupedByPhases.initiation,
                                "phase-string": "initiation",
                                phase: _vm.phases.initiation,
                                "current-phase":
                                  _vm.selectedScorecard.currentPhase,
                              },
                            }),
                            _c("milestone-accordion", {
                              attrs: {
                                list: _vm.kpisGroupedByPhases.scoping,
                                "phase-string": "scoping",
                                phase: _vm.phases.scoping,
                                "current-phase":
                                  _vm.selectedScorecard.currentPhase,
                              },
                            }),
                            _c("milestone-accordion", {
                              attrs: {
                                list: _vm.kpisGroupedByPhases.preparation,
                                "phase-string": "preparation",
                                phase: _vm.phases.preparation,
                                "current-phase":
                                  _vm.selectedScorecard.currentPhase,
                              },
                            }),
                            _c("milestone-accordion", {
                              attrs: {
                                list: _vm.kpisGroupedByPhases.implementation,
                                "phase-string": "implementation",
                                phase: _vm.phases.implementation,
                                "current-phase":
                                  _vm.selectedScorecard.currentPhase,
                              },
                            }),
                            _c("milestone-accordion", {
                              attrs: {
                                list: _vm.kpisGroupedByPhases.closeOut,
                                "phase-string": "closeOut",
                                phase: _vm.phases.closeOut,
                                "current-phase":
                                  _vm.selectedScorecard.currentPhase,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "modal-footer" }, [
                      _vm.pleaseWait
                        ? _c("span", [_vm._v(_vm._s(_vm.$t("pleaseWait")))])
                        : _vm._e(),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-secondary",
                          attrs: { type: "button", "data-dismiss": "modal" },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-primary",
                          attrs: {
                            type: "button",
                            disabled: !_vm.userHasWriteAccessToPlant,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.saveChanges()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("saveChanges")) + " ")]
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }